class CartItems extends HTMLElement {
    constructor() {
        super();
        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);
        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.item, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
    return [
        {
            id: `shopify-section-${document.getElementById('main-cart-items').dataset.id}`,
            section: document.getElementById('main-cart-items').dataset.id,
            selectors: ['.js-contents', '.section-cart__notification'],
        },
        {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selectors: ['.header__icon--cart']
        }
    ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            updates:{
                [line]: quantity
            },
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            this.getSectionsToRender().forEach((section => {
                section.selectors.forEach(selector => {
                    let p = document.getElementById(section.id)
                    const elementToReplace = p ? p.querySelector(selector) : document.querySelector(selector);
                    // const elementToReplace = document.getElementById(section.id).querySelector(selector) || document.querySelector(selector);
                    if(elementToReplace) elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], selector);
                });
            }));
            this.disableLoading();
        }).catch((e) => {
            console.log(e);
            alert(window.cartStrings.error)
            this.disableLoading();
        });
    }

    

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const cartItemElements = this.querySelector(`#CartItem-${line} .loading-spinner`);
        const footerElements = this.querySelector(`.cart-items__footer-content .loading-spinner`);
        [cartItemElements, footerElements].forEach((overlay) => overlay.classList.remove('hidden'));
        document.activeElement.blur();
    }

    disableLoading() {
        
    }
}

customElements.define('cart-items', CartItems);
class ItemRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items');
        cartItems.updateQuantity(this.dataset.item, 0);
      });
    }
  }
customElements.define('item-remove-button', ItemRemoveButton);